// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.0f96b6cfe8b64011bc71.js";
	// return url for filenames based on template
	return "" + {"299":"c67158026ea787bcc3cf","1167":"064d7cad2251daf5aa82"}[chunkId] + ".js";
};